import React, { useState, useEffect } from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { Navigate, useLocation } from 'react-router-dom'
import AppLoading from '../Common/AppLoading'

const AuthenticatedRoute: React.FC<{ component: React.ElementType }> = ({ component: Component }) => {
  const { inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [isInitialized, setIsInitialized] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      setIsInitialized(true)
    }
  }, [inProgress])

  if (!isInitialized) {
    return <AppLoading text='Checking your session…' />
  }

  if (!isAuthenticated) {
    // Save the current location (including the query string — e.g. a shared report deep
    // link's ?type=&id=) so we can redirect back to the exact same page after login.
    const from = `${location.pathname}${location.search}`
    console.log('[AuthenticatedRoute] Redirecting to login, saving path:', from)
    return <Navigate to='/login' state={{ from }} replace />
  }

  return <Component />
}

export default AuthenticatedRoute
